import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/blackberry': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M166 116.9c0 23.4-16.4 49.1-72.5 49.1h-70.1l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zM292.2 77.2c42.1 0 53.8 23.3 53.7 39.7 0 23.4-16.3 49.1-70.1 49.1h-70.1l18.7-88.8h67.8zM88.8 208.1c42.1 0 53.8 23.4 53.8 39.7 0 25.7-16.4 49.1-72.5 49.1h-70.1l21-88.8h67.8zM268.9 208.1c42 0 53.7 23.4 53.7 39.7 0 25.7-16.3 49.1-70.1 49.1h-70.1l18.7-88.8h67.8zM458.2 154.3c42.1 0 53.8 23.4 53.7 39.7 0 25.7-16.3 49.1-70.1 49.1h-70.1l18.7-88.8h67.8zM430.2 292.2c42.1 0 53.7 23.4 53.7 39.7 0 25.7-14 49.1-70.1 49.1h-70.1l18.7-88.8h67.8zM240.8 346c42.1 0 53.8 23.4 53.7 39.7 0 23.4-14 49.1-70.1 49.1h-70.1l18.7-88.8h67.8z'
      }
    ]
  }
})
